import type { JSX } from 'react'

import { SubstackNote } from './components/SubstackNote/SubstackNote'
import { Empty } from '../Common/Empty'
import { PostPreviewCard } from '../Common/styles'
import type { BaseDraftPreview, ProfilePreview } from '../types'

export const SubstackPreview = ({
  draft,
  profile,
}: {
  draft: BaseDraftPreview
  profile: ProfilePreview
}): JSX.Element => {
  if (draft.isEmpty) return <Empty />

  return (
    <PostPreviewCard data-testid="substack-preview">
      <SubstackNote content={draft} profile={profile} />
    </PostPreviewCard>
  )
}
